<template>
  <div class="events-list">
    <card-event  v-for="(event, index) in events" :event="event" :key="`${JSON.stringify(event)}${index}`" />
  </div>
</template>

<script>
import { Component, BaseComponent } from '@/libs/BaseComponent'
import EventCard from '@/modules/home/_components/EventCard'

@Component({
  components: {
    'card-event': EventCard
  },
  props: {
    events: {
      type: Array
    }
  }
})
export default class EventsList extends BaseComponent {}
</script>

<style lang="scss" scoped>
  .events-list {
    flex-wrap: wrap;
    overflow-y: auto;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
  }
</style>
